import { debounce } from 'lodash';
import { BaseController } from './BaseController';

export default class MenuController extends BaseController {
  id = 'MenuController';

  init() {
    this.root = this.getRoot();
    this.btn = this.singleChildNode('btn-toggle');
    this.btnClose = this.singleChildNode('btn-toggle-close');
    this.data = {
      minWidth: 800,
      expanded: false,
      menuOpenText: 'Close menu',
      menuClosedText: 'Open menu',
    };

    this.menuToggler();
    this.navigationListener();

    document.addEventListener('click', this.docClick);
    this.btn.addEventListener('click', this.btnToggle);
    this.btnClose.addEventListener('click', this.btnToggle);

    document.addEventListener('keyup', (e) => {
      if (this.data.expanded && e.keyCode === 27) {
        this.toggleMenu();
      }
      if (
        this.root.contains(document.activeElement) &&
        e.keyCode === 9 &&
        !this.data.expanded
      ) {
        this.toggleMenu();
      } else if (
        !this.root.contains(document.activeElement) &&
        e.keyCode === 9 &&
        this.data.expanded
      ) {
        this.toggleMenu();
      }
    });
  }

  docClick = (e) => {
    if (!this.root.contains(e.target) && this.data.expanded) {
      this.toggleMenu();
    }
  };

  btnToggle = (e) => {
    e.preventDefault();

    this.toggleMenu();
  };

  toggleMenu = () => {
    this.root.classList.toggle('menu-open');
    this.data.expanded = !this.data.expanded;
    this.btn.setAttribute('aria-expanded', this.data.expanded);
    this.btn.setAttribute(
      'aria-label',
      this.data.expanded ? this.data.menuOpenText : this.data.menuClosedText,
    );
  };

  navigationListener = () => {
    window.addEventListener('resize', debounce(this.menuToggler, 250));
  };

  menuToggler = () => {
    if (
      window.outerWidth <= this.data.minWidth &&
      !this.root.classList.contains('menu-active')
    ) {
      this.root.classList.add('menu-active');
    } else if (window.outerWidth > this.data.minWidth) {
      this.root.classList.remove('menu-active');
    }
  };
}
